// src/components/Features.jsx
import "./Features.css";
import {
  FaWifi,
  FaHdd,
  FaBroadcastTower,
  FaBolt,
  FaUsers,
  FaLock,
  FaSatelliteDish,
  FaStopwatch,
  FaShieldAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const features = [
  {
    icon: <FaHdd />,
    title: "Portable Storage",
    desc: "Take your data anywhere with compact, high-capacity storage solutions.",
  },
  {
    icon: <FaWifi />,
    title: "Offline Streaming",
    desc: "Stream content without internet connectivity in high quality.",
  },
  {
    icon: <FaBroadcastTower />,
    title: "Secure Broadcasting",
    desc: "Broadcast your content securely to multiple devices simultaneously.",
  },
  {
    icon: <FaBolt />,
    title: "Fast Transfer",
    desc: "Lightning-fast data transfer speeds for efficient workflow.",
  },
  {
    icon: <FaUsers />,
    title: "Multi-User Access",
    desc: "Share content with team members seamlessly and securely.",
  },
  {
    icon: <FaLock />,
    title: "Data Security",
    desc: "Enterprise-grade encryption for your sensitive data.",
  },
  {
    icon: <FaSatelliteDish />,
    title: "Edge Coverage",
    desc: "Extend your private mesh up to 200 feet with amplified antennas.",
  },
  {
    icon: <FaStopwatch />,
    title: "5-Min Setup",
    desc: "Power on, connect, and publish content-ready Wi-Fi in minutes.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Zero-Trust Mode",
    desc: "Device-level allowlists keep outsiders locked out automatically.",
  },
];

export default function Features() {
  return (
    <section className="features-section">
      <div className="features-header">
        <h2>Features</h2>
        <p>
          Discover the powerful features that make ChipServer the ultimate
          choice for mobile data management and streaming.
        </p>
      </div>

      <div className="features-grid">
        {features.map((feature, index) => (
          <Link to="/products" key={index} className="feature-card">
            <div className="feature-icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
